import { SxProps } from "@mui/material";

export const wrapperMain: SxProps = {
  "& .coin-row": {
    display: "flex",
    justifyContent: "space-between",
    cursor: "pointer",
    borderRadius: "8px",
    padding: "0 8px",
    "&:hover": {
      background: "rgba(60,70,119,0.9)",
    },
  },
  "& .coin-icon": {
    width: "32px",
    height: "32px",
  },
  "& h6 img": {
    position: "relative",
    left: "8px",
    top: "7px",
  },
  "& textarea": {
    width: "100%",
    background: "none",
    border: "none",
    fontSize: "1.1rem",
    color: "#9CA3AF",
  },
  "&>div:first-of-type": {
    width: "478px",
    maxWidth: "100%",
    margin: "0 auto",
  },
};
export const wrapperHeader: SxProps = {
  width: "100%",
  maxWidth: "100%",
  display: "flex",
  justifyContent: "space-between",
  "& h5": {
    fontWeight: "700",
  },
  "&>button:last-of-type": {
    fontSize: "18px",
    color: "#ffffff",
    fontWeight: "700",
  },
  "& .MuiStack-root": {
    right: "-30.5px",
    top: "3px",
  },
};

export const wrapperTopPart: SxProps = {
  justifyContent: "space-between",
  "& img": {
    borderRadius: "50%",
  },
};

export const wrapperItem: SxProps = {
  justifyContent: "space-between",
  width: "49%",
  "& p": {
    fontSize: "1rem",
  },
  "& h6": {
    fontWeight: "700",
    fontSize: "1.4rem",
  },
  "& h5": {
    fontWeight: "700",
    fontSize: "22px",
  },
};

export const wrapperCex: SxProps = {
  justifyContent: "space-between",
  padding: "10px",
  marginBottom: "20px",
  "& span": {
    fontSize: "1.3rem",
    marginLeft: "5px",
    position: "relative",
    top: "-3px",
  },
  "& img": {
    position: "relative",
    top: "7px",
  },
};
export const wrapperIcons: SxProps = {
  display: "flex",
  padding: "10px 0",
  "& img": {
    margin: "0 5px",
    position: "relative",
    top: "4px",
  },
  "& span": {
    opacity: "0.7",
  },
  borderBottom: "1px solid #FFFFFF21",
  borderTop: "1px solid #FFFFFF21",
};

export const wrapperMiddle: SxProps = {
  justifyContent: "space-between",
  "& h6": {
    fontWeight: "700",
    width: "100%",
  },
  "& p": {
    height: "auto",
    padding: "0",
    color: "#ffffff",
    opacity: "0.8",
    width: "100%",
  },
};
